import {
	type BaseConversationAction,
	type ChatAction,
	type ConversationAction,
	HandleActionType,
	LEGACY_DYNAMIC_SKILL_IDS,
	type LegacyDynamicSkillAction,
	type NestedAction,
	type SkillAction,
} from '../types';

export function isChatAction(action: ConversationAction): action is ChatAction {
	return action.handleType === HandleActionType.Chat;
}

export function isNestedAction(action: ConversationAction): action is NestedAction {
	return action.handleType === HandleActionType.Nested;
}

export function isSkillAction(
	action: ConversationAction,
): action is SkillAction | LegacyDynamicSkillAction {
	return action.handleType === HandleActionType.Skill;
}

/**
 * @deprecated Checks if a skill action uses the legacy `dynamicPrompt` behavior.
 * Only returns true for skill actions whose IDs are in the `LEGACY_DYNAMIC_SKILL_IDS` allowlist.
 */
export function isLegacyDynamicSkillAction(
	action: ConversationAction,
): action is LegacyDynamicSkillAction {
	return (
		action.handleType === HandleActionType.Skill &&
		'dynamicPrompt' in action &&
		LEGACY_DYNAMIC_SKILL_IDS.has(action.id)
	);
}

export function isBaseConversationAction(
	action: ConversationAction,
): action is BaseConversationAction {
	return isChatAction(action) || isNestedAction(action) || isSkillAction(action);
}
